import Main from "@/views/Main.vue";

const customerRoutes = [
  {
    path: "/incomplete",
    icon: "android-menu",
    title: "残缺商品管理",
    name: 'Incomplete',
    component: Main,
    children: [
      {
        path: "category",
        title: "品类补齐",
        name: 'IncompleteCategory',
        component: resolve => {
          require(["@/views/incomplete/category.vue"], resolve);
        }
      },
      {
        path: "config",
        title: "设置",
        name: 'IncompleteConfig',
        component: resolve => {
          require(["@/views/incomplete/cn/config.vue"], resolve);
        }
      },

      // ── CN 路由 ──
      {
        path: "cn/category",
        title: "品类补齐(CN)",
        name: 'IncompleteCategoryCn',
        component: resolve => {
          require(["@/views/incomplete/cn/category.vue"], resolve);
        }
      },
    ]
  }
]

export default customerRoutes
